export enum UgcTab {
  UgcTypeCostume = 1, // 服装设计
  UgcTypeMyROMemory = 4, // 我的RO记忆
  UgcTypePhoto = 5, // 美照分享
}

// 扩展 Window 类型
declare global {
  interface Window {
    platform_id: string;
    activity_name: string;
    game_id: number;
    activityDataLayer: any[];
    ShareFactory?: any; // 分享工厂
  }
}
